module.exports = __webpack_public_path__ + "media/images/japan/yellow-circle-be142e9ef64f51dff4da6fb069bdc18e.svg";